/*
 * View for default category name
 */

define(["marionette", "./template/categoryNameTemplate.html"], function (
  Marionette,
  CategoryNameTemplate,
) {
  var CategoryNameView = {};

  CategoryNameView.categoryNameView = Marionette.ItemView.extend({
    template: CategoryNameTemplate,
    nameError: function (errorMessage) {
      this.$el
        .find("#categoryDefaultNameText")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    textboxes: {
      "#categoryDefaultNameText": {
        enableSelector: "#categoryDefaultNameText",
        modelAttribute: "categoryName",
        placeholder: "admin.categories.category.name",
        textArea: false,
      },
    },
  });

  return CategoryNameView;
});
